import { getArchivedRequest } from 'store/storageunits/sagaActions';
import { useFetchViewStorageUnits } from '../hooks/useFetchViewStorageUnits';
import { useSelector, useDispatch } from 'react-redux';
import {
  getArchivedForDashboard,
  getHasMoreDataToRetrieve,
} from 'store/storageunits/selectors';
import { useDashboard } from '../context';
import { LIMIT } from 'config/paginationConfig';
import FileArea from '../components/FileArea';
import {
  ExplorerMode,
  SortType,
  StorageUnitType,
} from 'store/storageunits/types';
import StorageUnitGrid from '../components/StorageUnitGrid';
import StorageUnitList from '../components/StorageUnitList';
import partition from 'util/partition';
import { Stack } from '@mui/material';

const Bin = () => {
  const { explorerMode } = useDashboard();
  const dispatch = useDispatch();
  const moreDataToRetrieve = useSelector(getHasMoreDataToRetrieve);
  const units = useSelector(getArchivedForDashboard);

  useFetchViewStorageUnits(getArchivedRequest, {
    limit: LIMIT,
    offset: 0,
  });

  const fetchMore = async () => {
    dispatch(
      getArchivedRequest({
        limit: LIMIT,
        offset: units.length,
        replace: false,
      }),
    );
  };

  const [files, folders] = partition(
    units,
    (u) => u.type === StorageUnitType.File,
  );

  const showSorterOnFolders = folders.length > 0;

  return (
    <FileArea
      dataLength={units.length}
      fetchMore={fetchMore}
      canFetchMore={moreDataToRetrieve}
    >
      {explorerMode === ExplorerMode.Grid ? (
        <Stack spacing={2}>
          <StorageUnitGrid
            title='Folders'
            units={folders}
            type={StorageUnitType.Folder}
            showSorter={showSorterOnFolders}
          />
          <StorageUnitGrid
            title='Files'
            units={files}
            type={StorageUnitType.File}
            showSorter={!showSorterOnFolders}
            sx={{ pb: 10 }}
          />
        </Stack>
      ) : (
        <StorageUnitList
          units={[...folders, ...files]}
          columns={[
            { label: 'Name', type: SortType.ALPHABETICAL },
            { label: 'Access' },
            {
              label: 'Last modified',
              type: SortType.LAST_MODIFIED,
            },
            { label: 'Locked' },
            { label: 'Downloaded' },
            { label: 'State' },
          ]}
        />
      )}
    </FileArea>
  );
};

export default Bin;
